import 'extensions/ui-components/x-loader';
import 'extensions/ui-components/x-mord-group';
import 'extensions/ui-components/x-mord-group-multisystem';
import 'extensions/ui-components/x-mord-item';
import 'extensions/ui-components/x-mord-item-multisystem';
import {PageManager} from 'genesis-packages/core';
import 'pages/INVC/INVC.scss';
import './MORD.scss';

export default class MORD extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		const form = document.querySelector('.js-mord-form');
		if (form) {
			form.addEventListener('submit', () => this.handleSubmit(form));
		}

	}

	handleSubmit (form) {
		const items = form?.querySelectorAll('x-mord-item, x-mord-group-multisystem');
		const submitButtonElements = form?.querySelectorAll('[type="submit"]');
		let counter = 0;

		form.classList.add('is--loading');

		for (const item of items) {
			const itemValue = item.formattedValues;

			if (item.nodeName === 'X-MORD-GROUP-MULTISYSTEM') {
				for (const child of item.children) {
					counter++;
					form.appendChild(this.createHiddenInput(`Line_Items[ ${counter} ]:line_id`, child.lineId));
					form.appendChild(this.createHiddenInput(`Line_Items[ ${counter} ]:id`, child.id));
					form.appendChild(this.createHiddenInput(`Line_Items[ ${counter} ]:code`, child.code));
					form.appendChild(this.createHiddenInput(`Line_Items[ ${counter} ]:quantity`, child.quantity));
					form.appendChild(this.createHiddenInput(`Line_Items[ ${counter} ]:date`, itemValue.date));
				}

				continue;
			}

			if (itemValue.lineId === 0 && itemValue.quantity === 0) {
				continue;
			}

			counter++;

			form.appendChild(this.createHiddenInput(`Line_Items[ ${counter} ]:line_id`, itemValue.lineId));
			form.appendChild(this.createHiddenInput(`Line_Items[ ${counter} ]:id`, itemValue.id));
			form.appendChild(this.createHiddenInput(`Line_Items[ ${counter} ]:code`, itemValue.code));
			form.appendChild(this.createHiddenInput(`Line_Items[ ${counter} ]:quantity`, itemValue.quantity));
			form.appendChild(this.createHiddenInput(`Line_Items[ ${counter} ]:date`, itemValue.date));
		}

		for (const submitButtonElement of submitButtonElements) {
			submitButtonElement.disabled = true;
		}
	}

	createHiddenInput (name, value) {
		const input = document.createElement('input');
		input.type = 'hidden';
		input.name = name;
		input.value = value;

		return input;
	}

};
